/**
 * AcilirKart.jsx — başlığa tıklayınca aşağı doğru açılan kart (backlog #528, 2026-10-21).
 *
 * Ana Sayfa'daki widget'ların (FirmaAnasayfaListPage.jsx PanelCard) aynı görünümü: kırmızı başlık, sağda ok. Orası sayfa-yerel ve
 * sürükleme / "kaldır" düğmeleri taşıdığı için dokunulmadı; bu sade bir kopya. Durumu kendi tutar: `varsayilanAcik` yalnızca ilk
 * çizimde okunur (Yabancı Katılımcı'nın Evraklar'ındaki "Firma Evrakları" varsayılan KAPALI başlar).
 */
import React, { useState } from "react";
import { Card, CardBody, CardHeader, Collapse } from "reactstrap";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function AcilirKart({ baslik, varsayilanAcik = false, rozet = null, tour, children }) {
  const [acik, setAcik] = useState(varsayilanAcik);
  const toggle = () => setAcik((a) => !a);
  return (
    <Card className="mb-4" data-testid="acilir-kart" data-tour={tour}>
      <CardHeader
        role="button"
        tabIndex={0}
        aria-expanded={acik}
        onClick={toggle}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggle(); } }}
        className="bg-danger text-white d-flex justify-content-between align-items-center"
      >
        <span className="fw-semibold small text-uppercase">{baslik}</span>
        <div className="d-flex align-items-center gap-2">
          {rozet}
          {acik ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </div>
      </CardHeader>
      <Collapse isOpen={acik}>
        <CardBody>{children}</CardBody>
      </Collapse>
    </Card>
  );
}
